import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Star Jewels";
const SITE_URL = "https://starjewels-store.emergent.host"; // production URL used for canonical + og:url
const DEFAULT_DESCRIPTION =
  "Star Jewels — premium artificial jewelry & fashion jewellery hand-crafted in India. Shop earrings, necklaces, bracelets and rings.";

/**
 * <SEO> — drop-in per-page head manager.
 * Usage:
 *   <SEO title="…" description="…" image="…" jsonLd={...} />
 * All props are optional; sensible Star Jewels defaults are applied.
 */
export default function SEO({
  title,
  description,
  image,
  path = "",
  type = "website",
  jsonLd = null,
  noindex = false,
}) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Fine Fashion Jewellery`;
  const desc = (description || DEFAULT_DESCRIPTION).slice(0, 300);
  const url = `${SITE_URL}${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;
  const ogImage = image || `${SITE_URL}/logo.png`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
